module.exports = __webpack_public_path__ + "img/Alternate Data Pic.e8749901.jpg";